import {useQuery} from "@tanstack/react-query";

import {safelistingsService} from "../services";
import type {SafelistingAvailabilityParams} from "../types/safelisting-availability";

type UseSafelistingAvailabilityParams = {
  propertyId: number | null;
  vehicleId: number | null;
  plate: string | null;
  householdId: number | null;
  days: string[];
  enabled?: boolean;
};

export function useSafelistingAvailability({
  propertyId,
  vehicleId,
  plate,
  householdId,
  days,
  enabled = true,
}: UseSafelistingAvailabilityParams) {
  const hasScope = vehicleId != null || Boolean(plate?.trim());
  const isEnabled =
    enabled && propertyId != null && days.length > 0 && hasScope;

  const query = useQuery({
    queryKey: [
      "safelistings",
      "availability",
      propertyId,
      vehicleId,
      plate,
      householdId,
      days.join(","),
    ],
    queryFn: () => {
      const params: SafelistingAvailabilityParams = {
        property_id: propertyId!,
        days,
      };
      if (vehicleId != null) params.vehicle_id = vehicleId;
      if (plate?.trim()) params.plate = plate.trim();
      if (householdId != null) params.household_id = householdId;
      return safelistingsService.getAvailability(params);
    },
    enabled: isEnabled,
    staleTime: 0,
    gcTime: 0,
    retry: false,
  });

  return {
    ...query,
    availability: query.isSuccess ? query.data : null,
  };
}
